export enum AppState {
	Opened,
	AwaitingSave,
	Saving,
	Saved
}
